import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';
import ListMembers from './ListMembers';

//Create Member dependencies
import MyTooltip from '../common/MyTooltip';
import CreateMemberModel from './CreateMemberModel';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_ADMIN
} from '../common/redux/constantes';


export class DefaultPage extends Component {
  state = {
    openCreateMemberDialog:false,
    createMemberDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    memberEdit:{}
  }


  static propTypes = {
    member: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreateMemberDialog = ()=>{
    this.setState({openCreateMemberDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateMemberDialog = ()=>{
    this.setState({
      openCreateMemberDialog:true, 
      createMemberDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      memberEdit:{}
    });
  }

  editMember = (member)=>{
     this.setState({
      openCreateMemberDialog:true, 
      createMemberDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      memberEdit:member
    });
  }

  showMember = (member)=>{
     this.setState({
      openCreateMemberDialog:true, 
      createMemberDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      memberEdit:member
    });
  }

  render() {
    return (
      <div >
          <MySideBar>
            <ListMembers ref={instance => { this.list = instance; }} editMember={this.editMember} showMember={this.showMember}/>
            <CreateMemberModel 
              openDialog={this.state.openCreateMemberDialog} 
              closeDialog={this.closeCreateMemberDialog} 
              actionDialog={this.state.createMemberDialogAction}
              memberEdit={this.state.memberEdit}
            />
            {
              Number(localStorage.getItem("role")) === ROLE_ADMIN?
              (<MyTooltip openDialog={this.openCreateMemberDialog} />)
              :null
            }
        </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    member: state.member,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/member/DefaultPage.js